import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class OrgsRenovateService {
    public status = new Subject<number>();
    private _active = 0;

    public get active(): number {
        return this._active;
    }

    public set active(v: number) {
        this._active = v;
        this.status.next(v);
    }

    public pub(): void {
        this.active = Math.floor(Math.random() * 100000);
    }
}
